define.alias("shared/utils/string-formatters/remove-underscores", "calendar/utils/string-formatters/remove-underscores");